export const PREDEFINED_COLORS = [
  'rgba(89, 146, 190, 0.8)', // Blue
  'rgba(236, 140, 185, 0.8)', // Pink
  'rgba(245, 180, 110, 0.8)', // Orange
  'rgba(140, 190, 109, 0.8)', // Green
  'rgba(125, 125, 125, 0.8)', // Gray
  'rgba(102, 51, 153, 0.8)', // Purple
  'rgba(255, 99, 71, 0.8)', // Red
  'rgba(100, 149, 237, 0.8)', // Cornflower Blue
] as const;
